import type { Feature, FeatureGroup, FeatureModule } from '../../../types';
import { DEVELOPMENT_FEATURE_GROUP } from './group';
import { DEVELOPMENT_TICKET_DESIGNER_MODULE } from './ticket-designer';
import { DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_MODULE } from './membership-card-designer';
import { DEVELOPMENT_LINK2PAY_MODULE } from './link2pay';
import { DEVELOPMENT_DATA_IMPORTS_MODULE } from './data-imports';
import { DEVELOPMENT_MEMBERSHIP_PORTAL_MODULE } from './membership-portal';
import { DEVELOPMENT_SETTINGS_MODULE } from './settings';

export { DEVELOPMENT_FEATURE_GROUP } from './group';
export * from './ticket-designer';
export * from './membership-card-designer';
export * from './link2pay';
export * from './data-imports';
export * from './membership-portal';
export * from './settings';

const DEVELOPMENT_SUB_MODULES: FeatureModule[] = [
  DEVELOPMENT_TICKET_DESIGNER_MODULE,
  DEVELOPMENT_MEMBERSHIP_CARD_DESIGNER_MODULE,
  DEVELOPMENT_LINK2PAY_MODULE,
  DEVELOPMENT_DATA_IMPORTS_MODULE,
  DEVELOPMENT_MEMBERSHIP_PORTAL_MODULE,
  DEVELOPMENT_SETTINGS_MODULE,
];

const developmentGroups: FeatureGroup[] = [
  DEVELOPMENT_FEATURE_GROUP,
  ...DEVELOPMENT_SUB_MODULES.flatMap((m) => m.groups),
];
const developmentFeatures: Feature[] = DEVELOPMENT_SUB_MODULES.flatMap((m) => m.features);

export const DEVELOPMENT_MODULE: FeatureModule = {
  product: 'app',
  groups: developmentGroups,
  features: developmentFeatures,
};
